// 2020-06-27export { MyColColorPickerComponent } from './my-col-colorpicker.component';